module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figB01_profile-crowning.7accd6d6.png";